<div class="se-container">
    <se-spinner [isBusy]="chart?.isBusy" class="maincontentspinner">
        <div class="maincontent">
            <ng-container *ngIf="reportingWithoutTrace && !sopInstanceUID">
                <div class="se-content">
                    <se-fullscreen
                        [changeViewIfRightSidenav]="changeFullWidth"
                        [enableFullscreenMode]="false"
                        [fullscreen]="fullscreen"
                        class="chart"
                    >
                        <div id="noTracing">
                            <h4>{{ "ErrorNoTracing" | translate }}</h4>
                        </div>
                    </se-fullscreen>
                </div>
            </ng-container>

            <ng-container *ngIf="!reportingWithoutTrace || sopInstanceUID">
                <ecg-summary
                    *ngIf="!fullscreen && !mediaService.is16_9"
                    [hidden]="
                        !ecgState.detailsState.visible ||
                        chart?.layers.length !== 1 ||
                        !ecgState.detailsState.summaryState.visible
                    "
                    [layer]="chart?.activeLayer"
                >
                </ecg-summary>

                <div class="se-content">
                    <se-fullscreen
                        [changeViewIfRightSidenav]="changeFullWidth"
                        [enableFullscreenMode]="false"
                        [fullscreen]="fullscreen"
                        class="chart"
                    >
                        <caliper-and-measures
                            (caliperMeasuresRemove)="chartComponent.onMeasuresRemove($event)"
                            (caliperMeasuresRemoveAll)="chartComponent.clearAllMeasures()"
                            (closeCustomMeasuresClicked)="onCloseCustomMeasures()"
                            *ngIf="showCaliperAndMeasures"
                            [caliperMeasures]="chartComponent.measuresSummary.measuresHandle.measuresList"
                            [customMeasureButtons]="customMeasureButtons"
                            [customMeasures]="customMeasures"
                            [globalMeasures]="chart?.activeLayer?.ecgData?.originalWaveform.annotations"
                            [isApprovedOrSigned]="isApprovedOrSigned"
                            [readOnly]="readOnly"
                            [showCaliperMeasures]="canShowCaliperMeasures()"
                            [showCustomMeasures]="canShowCustomMeasures()"
                            [showGlobalMeasures]="canShowGlobalMeasures()"
                            class="measures-content"
                        >
                        </caliper-and-measures>

                        <div class="chart-container">
                            <ecg-chart
                                #chartComponent
                                (caliperActivated)="onCaliperActivate($event)"
                                [chart]="chart"
                                [class.item-collapse]="showLeadsAnnotations"
                                [hideWhileCentering]="hideWhileCentering"
                                [title]="chartTitle"
                                class="chart"
                            >
                            </ecg-chart>
                            <leads-annotations
                                #leadsAnnotations
                                *ngIf="
                                    showLeadsAnnotations && ecgState.detailsState.visible && chart?.layers.length === 1
                                "
                                [channels]="chart?.activeLayer?.ecgData?.derivedWaveform.channels"
                                [class.full-leads-annotations-width]="showLeadsAnnotations"
                                class="annotations"
                            >
                            </leads-annotations>
                            <!-- layout-fab-tools -->
                            <layout-fab-tools
                                (customMeasuresChange)="onCustomMeasuresChange($event)"
                                (fullscreenChange)="onFullscreenChange()"
                                (leadsAnnotationsChange)="onLeadsAnnotationsChange($event)"
                                (lowFilterChange)="onLowFilterChange($event)"
                                [(ecgConfiguration)]="ecgConfiguration"
                                [arrangementConfiguration]="arrangementConfiguration"
                                [chartLayersNumber]="chart.layers?.length"
                                [class.is-fullscreen]="fullscreen"
                                [enabledPrintAsDisplayed]="printAsDisplayed"
                                [isEcgReportingDetail]="isEcgReportingDetail"
                                [schillerFilters]="schillerFilters"
                                [showCustomMeasuresButton]="showCustomMeasuresButton"
                                [showGlobalMeasures]="showGlobalMeasures"
                                [showLeadsAnnotationsButton]="showLeadsAnnotationsButton"
                                [showLeadsAnnotations]="showLeadsAnnotations"
                                class="layout-fab-tools"
                            >
                            </layout-fab-tools>

                            <fixed-filters
                                [class.item-collapse]="showLeadsAnnotations"
                                [filters]="chart?.activeLayer?.filters"
                                [manufacturer]="chart?.activeLayer?.study?.manufacturer"
                                [schillerFilters]="schillerFilters"
                                class="fixed-filters"
                            >
                            </fixed-filters>
                        </div>
                    </se-fullscreen>

                    <div class="summary">
                        <ecg-summary
                            *ngIf="!fullscreen && mediaService.is16_9"
                            [hidden]="
                                !ecgState.detailsState.visible ||
                                chart?.layers.length !== 1 ||
                                !ecgState.detailsState.summaryState.visible
                            "
                            [layer]="chart?.activeLayer"
                            class="ecgsummary"
                        >
                        </ecg-summary>
                    </div>
                </div>
            </ng-container>
        </div>
    </se-spinner>
</div>
